import { ReactElement } from 'react';
import cc from 'classcat';
import { createArray } from 'utils/helpers/create-fake-array';
import { Skeleton } from 'newcomponents/UI/Skeleton';
import './index.less';
import '../index.less';

const COUNTER_STRIKE_STATISTICS_COLUMN_LENGTH = 20;

export const CounterStrikeStatisticsScoresSkeleton = (): ReactElement => {
  return (
    <div className="counterStrike__statistics-row team-scores counterStrike__statistics-row-team-scores-skeleton">
      {createArray(2).map(index => (
        <div key={index}>
          <div
            className="counterStrike__statistics-column team-score"
            style={{ width: 32 }}
          >
            {createArray(COUNTER_STRIKE_STATISTICS_COLUMN_LENGTH).map(key => (
              <div
                className={cc([
                  'counterStrike__statistics-column teamResult',
                  { 'teamResult--reverse': index === 1 }
                ])}
                key={key}
              >
                <Skeleton.Avatar
                  size="small"
                  active
                  style={{ width: 24, height: 24 }}
                  shape="circle"
                />
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};
